import $ from 'jquery';
import { getUser } from '~src/user';

const addUserDetailsToNavbar = (user) => {
  const orgName = user.org_pointer?.nome || '';
  const fullName =
    user.first_name && user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.username;

  // New DS profile card fields (navbar-private)
  $('#sidebar-profile-org').text(orgName);
  $('#sidebar-profile-user').text(fullName);
};

export const addOrgDataToNavbar = async () => {
  const { user } = await getUser();
  addUserDetailsToNavbar(user);
};
